var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./player.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-776ab970\"}!../../vue-loader/lib/selector?type=template&index=0!./player.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/src/player.vue
// module id = 1686
// module chunks = 1